import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // 'loading' | 'success' | 'error'
  const [status, setStatus] = useState(token ? 'loading' : 'error');
  const [error, setError] = useState(token ? '' : 'Lien invalide ou expiré');

  useEffect(() => {
    if (!token) return;

    let cancelled = false;
    api
      .get(`/auth/verify-email/${token}`)
      .then(() => {
        if (!cancelled) setStatus('success');
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Une erreur est survenue');
          setStatus('error');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center th-bg px-4 transition-colors duration-300">
      <div className="w-full max-w-sm animate-fadeInUp">
        <div className="text-center mb-8">
          <Link to="/" className="font-mono font-bold text-2xl text-accent tracking-[0.15em]">STRIDERR</Link>
          <p className="mt-2 text-sm th-text-secondary">Vérification de ton email</p>
        </div>

        <div className="border th-border p-6 th-bg-surface transition-colors duration-300 space-y-4">
          {status === 'loading' && (
            <p className="text-sm th-text font-mono">Vérification en cours...</p>
          )}

          {status === 'success' && (
            <>
              <p className="text-sm th-text">Email vérifié avec succès. Ton compte est activé.</p>
              <Link to="/login" className="text-accent hover:opacity-70 transition-opacity duration-150 font-mono text-sm">
                Se connecter
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="border border-status-rejected/30 text-status-rejected px-3 py-2 text-sm font-mono">
                {error}
              </div>
              <Link to="/login" className="text-accent hover:opacity-70 transition-opacity duration-150 font-mono text-sm">
                Retour à la connexion
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
